import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class RevenueTypeListService {

	private apiUrl = globalConst.baseAPI;

	constructor(private http: Http) { }

	searchRecipeType(token, descricao, status, orderby, sort, page) {
		

		
		
		
		
		
		

		var statusFilter = "";
		if (status != "") statusFilter = "and Ativo eq " + status;

		return this.http
		.get(this.apiUrl + "revenue/v1/getrevenue?$orderby=" + orderby + " " + sort + "&$top="+globalConst.paginationSkip+"&$skip=" + page + "&$filter=startswith(tolower(Descricao),'" + descricao.toLowerCase() + "') " + statusFilter, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json()).catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});

	}

}



// WEBPACK FOOTER //
// ./src/app/revenue-type/service/revenue-type-list/revenue-type-list.service.ts